import { useSelector } from "react-redux";
import MenuItem from "./menuItem";
import { AuthorityMenu } from "./authority-menu";
import { AuthorityUserMenu } from "./authorityuser-menu";
import useRoles from "../../constants/useRoles";

const SideBarMenu = () => {
  const { user } = useSelector((state) => state.auth);
  const { readOnly, readWrite, admin } = useRoles();

  if (!user) return null;
  const { user_type } = user;
  let menuToRender = [];
  if (user_type === "AUTHORITY") {
    if (admin) {
      menuToRender = AuthorityMenu;
    } else if (readWrite) {
      menuToRender = AuthorityUserMenu;
    } else if (readOnly) {
      menuToRender = AuthorityUserMenu.filter((_, index) => index !== 0);
    }
  }

  return (
    <div className="sidebar-menu">
      <ul className="menu" data-bs-theme="dark">
        <li className="sidebar-title" data-bs-theme="dark">
          {/* Menu */}
        </li>
        {menuToRender.map((item, index) => (
          <MenuItem key={"menu" + index} item={item} index={index} data-bs-theme="dark" />
        ))}
      </ul>
    </div>
  );
};

export default SideBarMenu;
